import { gql } from '@apollo/client';
import { graphMutation } from '@services/commService';

export const MOVE_USER_TO_NEXT_ACTIVITY = gql`
  mutation MoveUserToNextActivity($userId: String!) {
    moveUserToNextCourseActivity(userId: $userId) {
      courseId
      skillId
      entityId
      entityType
    }
  }
`;

export const moveUserToNextActivity = async (userId) => {
  const result = await graphMutation(MOVE_USER_TO_NEXT_ACTIVITY, { userId });

  return result?.data?.moveUserToNextCourseActivity;
};